import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  LucideAngularModule,
  Tv,
  Globe,
  Mountain,
  Train,
  Video,
  Package,
  Utensils,
  Droplet
} from 'lucide-angular';
import { TranslocoModule } from '@jsverse/transloco';
import { TooltipModule } from 'primeng/tooltip';
import { AdemeEquivalence, ImpactCo2Meta } from '../../models/ademe-equivalence';

@Component({
  selector: 'app-ademe-equivalences',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    TranslocoModule,
    TooltipModule
  ],
  templateUrl: './ademe-equivalences.component.html'
})
export class AdemeEquivalencesComponent {
  equivalences = input<AdemeEquivalence[]>([]);
  meta = input.required<ImpactCo2Meta>();
  /** Travellers the trip's equivalences are shared between: 1 in group view. */
  travellers = input(1);

  /**
   * The equivalences for one of `travellers`. They come floored for the whole
   * trip, and flooring a floored count divided by a whole number gives what
   * flooring the exact share would (⌊⌊x⌋/n⌋ = ⌊x/n⌋), so the per-traveller
   * figures need no call to the API. A '<1' stays below 1.
   */
  displayedEquivalences = computed(() => {
    const travellers = this.travellers();
    if (travellers <= 1) return this.equivalences();
    return this.equivalences().map((eq): AdemeEquivalence => {
      const value = eq.value === '<1' ? 0 : Math.floor(eq.value / travellers);
      // Formatted as the API formats `displayValue`.
      return value < 1
        ? { ...eq, value: '<1', displayValue: '<1' }
        : { ...eq, value, displayValue: value.toLocaleString('fr-FR') };
    });
  });

  getIcon(slug: string): typeof Tv {
    const iconMap: Record<string, typeof Tv> = {
      streaming_harry_potter: Tv,
      world_tour_car: Globe,
      ski_days: Mountain,
      paris_berlin_train: Train,
      videoconference_hours: Video,
      home_delivery: Package,
      chicken_meal: Utensils,
      tap_water_liters: Droplet
    };
    return iconMap[slug] || Globe;
  }

  isLessThanOne(value: number | '<1'): boolean {
    return value === '<1';
  }
}
